module.exports = __webpack_public_path__ + "img/mobaku.13e2d171.png";